import { useCallback, useEffect, useState } from 'react';
import guidesApi from '../services/guides';

export function useGuides(context = {}, options = {}) {
  const enabled = options.enabled !== false;
  const [primary, setPrimary] = useState(null);
  const [secondary, setSecondary] = useState([]);
  const [all, setAll] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');

  const clear = useCallback(() => {
    setPrimary(null);
    setSecondary([]);
    setAll([]);
  }, []);

  const refresh = useCallback(async () => {
    if (!enabled || !context?.routeKey) {
      clear();
      return null;
    }

    try {
      setIsLoading(true);
      setError('');
      const response = await guidesApi.listGuides(context);
      setPrimary(response?.primary || null);
      setSecondary(Array.isArray(response?.secondary) ? response.secondary : []);
      setAll(Array.isArray(response?.all) ? response.all : []);
      return response;
    } catch (loadError) {
      setError(loadError?.message || 'Failed to load guides.');
      clear();
      return null;
    } finally {
      setIsLoading(false);
    }
  }, [
    enabled,
    clear,
    context?.routeKey,
    context?.pathname,
    context?.tenantId,
    context?.listingId,
    context?.offerId,
    context?.campaignId,
    context?.includeCompleted,
    context?.max,
  ]);

  useEffect(() => {
    refresh();
  }, [refresh]);

  return {
    primary,
    secondary,
    all,
    isLoading,
    error,
    refresh,
  };
}

export default useGuides;
